module.exports = __webpack_public_path__ + "static/media/card-Generic.db51e9ea.svg";